export enum LocalStorageKeyEnum {
  TOKEN = 'accessToken',
  PRODUCTS = '_products_',
  USER = '_user_'
}
